module.exports = {
	"fileName": "/contracts/MetaCoin.sol",
	"name": "MetaCoin",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				}
			],
			"name": "getBalanceInEth",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "receiver",
					"type": "address"
				},
				{
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "sendCoin",
			"outputs": [
				{
					"name": "sufficient",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				}
			],
			"name": "getBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_from",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "_to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		}
	],
	"source": "pragma solidity ^0.4.2;\n\nimport \"./ConvertLib.sol\";\n\n// This is just a simple example of a coin-like contract.\n// It is not standards compatible and cannot be expected to talk to other\n// coin/token contracts. If you want to create a standards-compliant\n// token, see: https://github.com/ConsenSys/Tokens. Cheers!\n\ncontract MetaCoin {\n\tmapping (address => uint) balances;\n\n\tevent Transfer(address indexed _from, address indexed _to, uint256 _value);\n\n\tfunction MetaCoin() {\n\t\tbalances[tx.origin] = 10000;\n\t}\n\n\tfunction sendCoin(address receiver, uint amount) returns(bool sufficient) {\n\t\tif (balances[msg.sender] < amount) return false;\n\t\tbalances[msg.sender] -= amount;\n\t\tbalances[receiver] += amount;\n\t\tTransfer(msg.sender, receiver, amount);\n\t\treturn true;\n\t}\n\n\tfunction getBalanceInEth(address addr) returns(uint){\n\t\treturn ConvertLib.convert(getBalance(addr),2);\n\t}\n\n\tfunction getBalance(address addr) returns(uint) {\n\t\treturn balances[addr];\n\t}\n}\n",
	"abiDocs": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				}
			],
			"name": "getBalanceInEth",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "getBalanceInEth(address)",
			"signatureHash": "7bd703e8"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "receiver",
					"type": "address"
				},
				{
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "sendCoin",
			"outputs": [
				{
					"name": "sufficient",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "sendCoin(address,uint256)",
			"signatureHash": "90b98a11"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				}
			],
			"name": "getBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "getBalance(address)",
			"signatureHash": "f8b2cb4f"
		},
		{
			"inputs": [],
			"payable": false,
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_from",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "_to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_value",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event",
			"signature": "Transfer(address,address,uint256)",
			"signatureHash": "ddf252ad"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./docs/MetaCoin.json
// module id = 1081
// module chunks = 0